export enum LoadingType {
  Idle = 0,
  More = 1,
  Refresh = 2,
  Background = 3,
}
